import { Controller } from "@hotwired/stimulus"

// Controla a sincronização entre o input de cor e o campo de texto
export default class extends Controller {
  static targets = ["colorInput", "textInput"]

  connect() {
    // Inicializa o valor do campo de texto
    this.textInputTarget.value = this.colorInputTarget.value
  }

  onColorChange(event) {
    const color = event.target.value.toUpperCase()
    this.textInputTarget.value = color
  }

  onTextChange(event) {
    const value = event.target.value
    if (this.isValidHexColor(value)) {
      this.colorInputTarget.value = value
    }
  }

  onTextBlur(event) {
    let value = event.target.value
    if (value && !value.startsWith('#')) {
      value = '#' + value
      if (this.isValidHexColor(value)) {
        event.target.value = value.toUpperCase()
        this.colorInputTarget.value = value
      }
    }
  }

  isValidHexColor(value) {
    return /^#[0-9A-Fa-f]{6}$/.test(value)
  }
} 